(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDeleteController',ModelosdeimpresoraDeleteController);

    ModelosdeimpresoraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modelosdeimpresora'];

    function ModelosdeimpresoraDeleteController($uibModalInstance, entity, Modelosdeimpresora) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modelosdeimpresora.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
